import { render } from "./SendTemplate.vue?vue&type=template&id=475801b4&scoped=true"
import script from "./SendTemplate.vue?vue&type=script&lang=js"
export * from "./SendTemplate.vue?vue&type=script&lang=js"

import "./SendTemplate.vue?vue&type=style&index=0&id=475801b4&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/projects/sms_agent/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475801b4"]])

export default __exports__